/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section3MedicalTypes = [MedicalTypeIds.WorkingConfinedSpaces];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section3Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.StorageTanks,
        questionText: "Storage tanks",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.StorageTanksFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.Silos,
        questionText: "Silos",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.SilosFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.Sewers,
        questionText: "Sewers",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.SewersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.Vats,
        questionText: "Vats",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.VatsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.Ductwork,
        questionText: "Ductwork",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.DuctworkFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.PoisonousGas,
        questionText: "Poisonous gas, fume or vapour",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.PoisonousGasFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.ResiduesLeftInTanks,
        questionText: "Residues left in tanks, vessels etc",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.ResiduesLeftInTanksFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.ReactionVessels,
        questionText: "Reaction vessels",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.ReactionVesselsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.EnclosedDrains,
        questionText: "Enclosed drains",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.EnclosedDrainsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.OpenToppedChambers,
        questionText: "Open-topped chambers",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.OpenToppedChambersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.CombustionChambers,
        questionText: "Combustion chambers in furnaces etc",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.CombustionChambersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.UnventilatedPoorlyVentilatedRooms,
        questionText: "Unventilated or poorly ventilated rooms",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.UnventilatedPoorlyVentilatedRoomsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.HotConditions,
        questionText: "Hot conditions",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.HotConditionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.DustPresentHighConcentrations,
        questionText: "Dust present in high concentrations",
        medicalTypes: section3MedicalTypes
    },
    {
        id: questionIds.DustPresentHighConcentrationsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section3MedicalTypes
    }
];
/* eslint-enable max-len */
